import { useDispatch } from 'react-redux';
import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { OfferFlatType } from '../models';
import { setViewTotalItems } from '../store';

export function useViewFlats(payload?: { id?: number; page?: number }) {
  const dispatch = useDispatch();
  const stateId = useAppSelector(({ offerReducer }) => offerReducer.view?.id);
  const statePage = useAppSelector(({ offerReducer }) => offerReducer.view?.page) || 1;
  const houseId = useAppSelector(({ realtorOfferReducer }) => realtorOfferReducer.view?.house?.id);

  const id = payload?.id || stateId;
  const page = payload?.page || statePage;

  const { data, ...arg } = useQuery<{
    flats: OfferFlatType[];
    totalPages: number;
    currentPage: number;
    totalElements: number;
  }>(
    ['realtor-offer-view-flats', id, page, houseId],
    async () => {
      const { data } = await $api.post(`/v1/flat/offer?offerId=${id}`, {
        page,
        size: 6,
        houses: houseId ? [houseId] : undefined
      });
      const totalPages = data?.data?.totalPages || 0;
      const currentPage = data?.data?.currentPage || 0;
      const totalElements = data?.data?.totalElements || 0;

      dispatch(
        setViewTotalItems({
          totalElements,
          currentPage
        })
      );

      return { flats: data?.data?.data, totalPages, currentPage, totalElements };
    },
    {
      retry: false,
      enabled: !!id
    }
  );

  return { ...data, ...arg };
}
